import { useTranslation } from "react-i18next";
import { useSettings } from "../../../../context/settings";

function TimelineItemContent({ item }) {
  const { t } = useTranslation();
  const { formatDateTime } = useSettings();
  const meta = item.meta || {};
  const changes = meta.changes;

  return (
    <p className="crm-vertical-timeline-content">
      {item.title && <span>{item.title}</span>}
      {item.body && <><br />{item.body}</>}
      {changes && Array.isArray(changes) && (
        <>
          <br />
          {changes.map((change, i) => (
            <span key={i}>
              <b>{change.field}</b> {t('crm.wasUpdatedFrom')}{" "}
              {change.old ? <b>{change.old}</b> : t('crm.blankValue')} {t('crm.updatedTo')}{" "}
              <b>{change.new}</b>
              <br />
            </span>
          ))}
        </>
      )}
      <div className="small mt-1 text-muted">
        {item.created_by && <>{t('crm.by')} {item.created_by?.firstname} </>}
        {formatDateTime(item.created_at)}
      </div>
    </p>
  );
}

export default TimelineItemContent;